import "@/App.css";
import { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import LandingPage from "./pages/LandingPage";
import { api } from "./lib/api";

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const PropertyDetail = lazy(() => import("./pages/PropertyDetail"));
const LegalNotice = lazy(() => import("./pages/LegalNotice"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const AllProperties = lazy(() => import("./pages/AllProperties"));
const Estimation = lazy(() => import("./pages/Estimation"));

function PageFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6] text-[#6B6B6B]">
      Chargement...
    </div>
  );
}

function RequireAuth({ children }) {
  const [state, setState] = useState("checking"); // checking | ok | nope

  useEffect(() => {
    let cancelled = false;
    api.me()
      .then(() => { if (!cancelled) setState("ok"); })
      .catch(() => { if (!cancelled) setState("nope"); });
    return () => { cancelled = true; };
  }, []);

  if (state === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6] text-[#6B6B6B]">
        Vérification de la session...
      </div>
    );
  }
  if (state === "nope") return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  const router = (
    <BrowserRouter>
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/biens" element={<AllProperties />} />
          <Route path="/biens/:id" element={<PropertyDetail />} />
          <Route path="/estimation" element={<Estimation />} />
          <Route path="/mentions-legales" element={<LegalNotice />} />
          <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminDashboard />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );

  return (
    <div className="App">
      {RECAPTCHA_SITE_KEY ? (
        <GoogleReCaptchaProvider
          reCaptchaKey={RECAPTCHA_SITE_KEY}
          scriptProps={{ async: true, defer: true, appendTo: "head" }}
          container={{ parameters: { badge: "bottomright" } }}
        >
          {router}
        </GoogleReCaptchaProvider>
      ) : (
        router
      )}
    </div>
  );
}

export default App;
